var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.42629 5.86744C2.42632 4.93728 3.18039 4.18326 4.11055 4.18329L15.9 4.18366C16.8302 4.18369 17.5842 4.93776 17.5842 5.86793L17.5838 16.8153C17.5838 17.7455 16.8297 18.4995 15.8996 18.4995L4.1101 18.4991C3.17994 18.499 2.42591 17.745 2.42594 16.8148L2.42629 5.86744ZM15.9 5.86787L4.1105 5.8675L4.11015 16.8149L15.8996 16.8152L15.9 5.86787Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47903 2.49918C7.94411 2.4992 8.32112 2.87623 8.32111 3.34132L8.321 6.70974C8.32099 7.17482 7.94395 7.55183 7.47887 7.55182C7.01379 7.5518 6.63678 7.17477 6.63679 6.70968L6.6369 3.34126C6.63691 2.87618 7.01395 2.49917 7.47903 2.49918Z",
    fill: "#21272F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.41385 9.23587C2.41386 8.77078 2.7909 8.39377 3.25598 8.39379L16.7091 8.39422C17.1742 8.39423 17.5512 8.77127 17.5512 9.23635C17.5512 9.70143 17.1741 10.0784 16.7091 10.0784L3.25593 10.078C2.79084 10.078 2.41383 9.70095 2.41385 9.23587Z",
    fill: "#21272F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5317 2.49935C12.9967 2.49936 13.3738 2.8764 13.3737 3.34148L13.3736 6.7099C13.3736 7.17498 12.9966 7.55199 12.5315 7.55198C12.0664 7.55196 11.6894 7.17493 11.6894 6.70985L11.6895 3.34142C11.6895 2.87634 12.0666 2.49933 12.5317 2.49935Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.7505be47d3333c8d06fec1fcba6e84ea.svg";
export { ForwardRef as ReactComponent };